import { ICompilation } from '../../types/promosPage';
import { IApplicationState } from '../../types/redux';

export const selectCompilations = (state: IApplicationState): ICompilation[] => {
  return state.promosPage.compilations;
};
